import axios from "axios"

// In development: http://localhost:5000/api
// In production:  set REACT_APP_API_URL in .env.production
const API = axios.create({
  baseURL: "https://apis.rovers.ke/api",
  headers: { "Content-Type": "application/json" },
})

// Attach JWT token to every request automatically
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("ra_token")
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Auto-redirect to home on 401 (expired/invalid token)
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("ra_token")
      localStorage.removeItem("ra_token_type")
      if (!window.location.pathname.includes("/ra-control-panel")) {
        window.location.href = "/"
      }
    }
    return Promise.reject(err)
  }
)

export default API
